import Model from "./abstract/Model";

export default class Image extends Model {

  constructor(props) {
    super();

    this.initializeAttributes(props, {});
  }

  get url_private() {
    return config.app.api_url + '/images/' + this.id;
  }
}
